/* eslint-disable import/newline-after-import, import/first */

//region 1. Platform Libraries
import bodyParser from 'body-parser';
import express from 'express';
const ipaddr = require('ipaddr.js');
import MongoClient from 'mongodb';
//endregion

//region 2. Project Libraries
import checkObjectID from '../middleware/checkObjectID';
import checkPort from '../middleware/checkPort';
import checkPublicIP from '../middleware/checkPublicIP';
//endregion

const context = {
        router: express.Router(),
        streamers: null,
        logger: null,
};

context.router.post('/', bodyParser.json());
context.router.post('/', checkPublicIP);
context.router.post('/', checkPort);
context.router.post('/', (req, res) => {
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'POST /streamers' });
        log('debug', JSON.stringify(req.body, null, 2));
        const now = new Date();
        const streamer = {
                public_ip: req.body.publicIp,
                private_ip: ipaddr.process(req.ip).toString(),
                port: req.body.port,
                created: now,
                updated: now,
        };
        context.streamers.insertOne(streamer, (err, result) => {
                if (err) {
                        log('error', err.message);
                        res.status(500).send(err.message);
                        return;
                }
                log('info', `Streamer ${result.insertedId} Created`);
                res.type('text/plain');
                res.status(201).send(new Buffer(`${result.insertedId}`));
        });
});

context.router.put('/:id', bodyParser.json());
context.router.put('/:id', checkObjectID);
context.router.put('/:id', (req, res) => {
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: `PUT ${req.originalUrl}` });
        log('debug', JSON.stringify(req.body, null, 2));
        [
                'streamIds',
                'cpuLoad',
                'mem',
        ].forEach((property) => {
                if ({}.hasOwnProperty.call(req.body, property)) {
                        return;
                }
                const message = `Heartbeat Body Contains No ${property}`;
                log('error', message);
                res.status(400).send(message);
        });
        const diff = {
                updated: new Date(),
                stream_ids: req.body.streamIds,
                cpu_load: Math.ceil(req.body.cpuLoad),
                mem_load: Math.ceil(req.body.mem.load),
                mem_current: Math.ceil(req.body.mem.current),
                mem_total: Math.ceil(req.body.mem.total),
        };
        const _id = new MongoClient.ObjectID(req.params.id);
        context.streamers.updateOne({ _id }, { $set: diff }, (err, result) => {
                if (err) {
                        log('error', err.message);
                        res.status(500).send(err.message);
                        return;
                }
                if (!result.matchedCount) {
                        const message = 'Streamer Not Found';
                        log('error', message);
                        res.status(500).send(message);
                        return;
                }
                log('info', '200 OK');
                res.sendStatus(200);
        });
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /streamers
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {MongoClient.Db} options.database Associated Database
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountStreamers(options) {
        context.logger = options.logger;
        const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountStreamers' });
        log('debug', 'Mounting router for /streamers....');
        options.app.use('/streamers', context.router);
        context.streamers = options.database.collection('streamers');
        log('info', 'Router for /streamers Mounted');
}
